// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dictionary-page .large-button {
  margin-top: 15px;
}
.dictionary-page .segment-panel {
  background-color: #ffffff; /* white background */
  border-radius: 8px; /* optional, nice rounded corners */
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1); /* optional, subtle shadow */
  padding: 16px;
  width: 75%; /* 3/4 of screen width */
  max-width: 900px; /* optional max width for very large screens */
}
.dictionary-page .segment-inputs-row {
  display: flex;
  align-items: flex-end; /* align items to bottom to align with save button */
  width: 100%;
  gap: 20px; /* reduced gap between inputs */
}
.dictionary-page .segment-save-button {
  display: flex;
  align-items: flex-end; /* align to the bottom of the row */
  margin-left: auto; /* push to right */
  margin-bottom: 0; /* remove bottom margin */
}
.dictionary-page .segment-save-button .large-button {
  margin-top: 0 !important; /* override any margin from button */
  margin-bottom: 0 !important; /* ensure no bottom margin */
}

.segment-error {
  color: red; /* make error text red */
  font-size: 15px; /* smaller text */
  margin-top: 4px; /* some spacing from input */
}

.segment-input {
  display: flex;
  flex-direction: column;
  flex: 1 1; /* allow inputs to grow and take equal space */
  min-width: 200px; /* increased minimum width */
  max-width: 300px; /* maximum width to prevent too wide inputs */
  align-self: flex-end; /* ensure the input container aligns to the bottom */
}
.segment-input label {
  font-size: 0.875rem !important; /* same as Anchor MultiSelect labels */
  font-weight: 500 !important; /* slightly bolder weight for better visibility */
  color: #333 !important; /* darker color similar to Anchor labels */
  margin-bottom: 8px !important; /* similar spacing to Anchor components */
  text-transform: none !important; /* no text transform */
  line-height: 1.5 !important; /* consistent line height */
}

.segment-info {
  display: flex;
  align-items: center;
  gap: 8px; /* space between icon and text */
  margin-bottom: 16px;
  font-size: 0.9rem;
  color: #666;
}
.segment-info svg {
  flex-shrink: 0; /* prevent icon from shrinking */
}

.input-with-prefix {
  position: relative;
  width: 100%; /* use full width of the segment-input container */
}

.input-prefix {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: small;
  pointer-events: none;
  color: #555;
}

.large-input {
  padding-left: 28px !important; /* space for prefix */
  height: 50px;
  font-size: smaller;
}

.dictionary-list .dictionary-list-body .dictionary-list-item {
  border: solid 1px var(--border-color);
  background: var(--color-white);
  border-radius: 0.25rem;
  cursor: pointer;
}
.dictionary-list .dictionary-list-body .dictionary-list-item .dictionary-list-item-icon {
  background-color: var(--color-maersk-blue);
}

.dictionary-page .error-message {
  color: var(--color-red);
  font-size: var(--font-size-md);
  font-weight: 600;
}
.dictionary-page .mandatory {
  color: var(--color-red);
}
.dictionary-page .add-button-dictionary {
  margin-top: 28px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dictionary/Dictionary.scss"],"names":[],"mappings":"AAEE;EACE,gBAAA;AADJ;AAIE;EACE,yBAAA,EAAA,qBAAA;EACA,kBAAA,EAAA,mCAAA;EACA,wCAAA,EAAA,4BAAA;EACA,aAAA;EACA,UAAA,EAAA,wBAAA;EACA,gBAAA,EAAA,8CAAA;AAFJ;AAKE;EACE,aAAA;EACA,qBAAA,EAAA,oDAAA;EACA,WAAA;EACA,SAAA,EAAA,+BAAA;AAHJ;AAME;EACE,aAAA;EACA,qBAAA,EAAA,mCAAA;EACA,iBAAA,EAAA,kBAAA;EACA,gBAAA,EAAA,yBAAA;AAJJ;AAMI;EACE,wBAAA,EAAA,oCAAA;EACA,2BAAA,EAAA,4BAAA;AAJN;;AASA;EACE,UAAA,EAAA,wBAAA;EACA,eAAA,EAAA,iBAAA;EACA,eAAA,EAAA,4BAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,SAAA,EAAA,8CAAA;EACA,gBAAA,EAAA,4BAAA;EACA,gBAAA,EAAA,6CAAA;EACA,oBAAA,EAAA,oDAAA;AANF;AAQE;EACE,8BAAA,EAAA,sCAAA;EACA,2BAAA,EAAA,iDAAA;EACA,sBAAA,EAAA,0CAAA;EACA,6BAAA,EAAA,yCAAA;EACA,+BAAA,EAAA,sBAAA;EACA,2BAAA,EAAA,2BAAA;AANJ;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA,EAAA,gCAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAPF;AASE;EACE,cAAA,EAAA,gCAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,WAAA,EAAA,kDAAA;AARF;;AAWA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;AARF;;AAWA;EACE,6BAAA,EAAA,qBAAA;EACA,YAAA;EACA,kBAAA;AARF;;AAaQ;EACI,qCAAA;EACA,8BAAA;EACA,sBAAA;EACA,eAAA;AAVZ;AAWY;EACI,0CAAA;AAThB;;AAgBI;EACI,uBAAA;EACA,8BAAA;EACA,gBAAA;AAbR;AAeI;EACI,uBAAA;AAbR;AAeI;EACI,gBAAA;AAbR","sourcesContent":[".dictionary-page {\n\n  .large-button {\n    margin-top: 15px;\n  }\n\n  .segment-panel {\n    background-color: #ffffff; /* white background */\n    border-radius: 8px;        /* optional, nice rounded corners */\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1); /* optional, subtle shadow */\n    padding: 16px;\n    width: 75%; /* 3/4 of screen width */\n    max-width: 900px; /* optional max width for very large screens */\n  }\n\n  .segment-inputs-row {\n    display: flex;\n    align-items: flex-end; /* align items to bottom to align with save button */\n    width: 100%;\n    gap: 20px; /* reduced gap between inputs */\n  }\n\n  .segment-save-button {\n    display: flex;\n    align-items: flex-end; /* align to the bottom of the row */\n    margin-left: auto; /* push to right */\n    margin-bottom: 0; /* remove bottom margin */\n    \n    .large-button {\n      margin-top: 0 !important; /* override any margin from button */\n      margin-bottom: 0 !important; /* ensure no bottom margin */\n    }\n  }\n}\n\n.segment-error {\n  color: red;          /* make error text red */\n  font-size: 15px;     /* smaller text */\n  margin-top: 4px;     /* some spacing from input */\n}\n\n.segment-input {\n  display: flex;\n  flex-direction: column;\n  flex: 1; /* allow inputs to grow and take equal space */\n  min-width: 200px; /* increased minimum width */\n  max-width: 300px; /* maximum width to prevent too wide inputs */\n  align-self: flex-end; /* ensure the input container aligns to the bottom */\n  \n  & label {\n    font-size: 0.875rem !important; /* same as Anchor MultiSelect labels */\n    font-weight: 500 !important; /* slightly bolder weight for better visibility */\n    color: #333 !important; /* darker color similar to Anchor labels */\n    margin-bottom: 8px !important; /* similar spacing to Anchor components */\n    text-transform: none !important; /* no text transform */\n    line-height: 1.5 !important; /* consistent line height */\n  }\n}\n\n.segment-info {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* space between icon and text */\n  margin-bottom: 16px;\n  font-size: 0.9rem;\n  color: #666;\n  \n  svg {\n    flex-shrink: 0; /* prevent icon from shrinking */\n  }\n}\n\n.input-with-prefix {\n  position: relative;\n  width: 100%; /* use full width of the segment-input container */\n}\n\n.input-prefix {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: small;\n  pointer-events: none;\n  color: #555;\n}\n\n.large-input {\n  padding-left: 28px !important; /* space for prefix */\n  height: 50px;\n  font-size: smaller;\n}\n\n.dictionary-list {\n    .dictionary-list-body {\n        .dictionary-list-item {\n            border: solid 1px var(--border-color);\n            background: var(--color-white);\n            border-radius: 0.25rem;\n            cursor: pointer;\n            .dictionary-list-item-icon {\n                background-color: var(--color-maersk-blue);\n            }\n        }\n    }\n}\n\n.dictionary-page {\n    .error-message {\n        color: var(--color-red);\n        font-size: var(--font-size-md);\n        font-weight: 600;\n    }\n    .mandatory {\n        color: var(--color-red);\n    }\n    .add-button-dictionary{\n        margin-top: 28px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
